import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';
import { FC, memo, useEffect, useRef } from 'react';

import Img from '../../../components/img/Img';

const SX_BOX: SxProps<Theme> = {
  height: '520px',
  overflow: 'hidden',
  position: 'relative',
};

const SX_IMG: SxProps<Theme> = {
  maxWidth: 'none',
  position: 'absolute',
};

const PageImageAS: FC = () => {
  const boxRef = useRef<HTMLElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const align = (box: HTMLElement, image: HTMLImageElement): void => {
      const sectionW = parseInt(getComputedStyle(box).width);
      image.style.left = sectionW > 800 ? -((2000 - sectionW) >> 1) + 'px' : '-450px';
    };

    const handleResize = (): void => {
      const box = boxRef.current;
      const img = imgRef.current;
      if (box && img) align(box, img);
    };
    handleResize();

    window.addEventListener('resize', handleResize);
    return (): void => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Box ref={boxRef} sx={SX_BOX}>
      <Img
        alt='Alexander Solovev'
        ref={imgRef}
        src='/img/header-solovev-defense-kampfkunst.jpg'
        sx={SX_IMG}
      />
    </Box>
  );
};

export default memo(PageImageAS);
